import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SyncProcessorService } from '@vending/sync-engine-client';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { Observable } from 'rxjs';
import { ErrorService } from 'src/packages/mitsBasics';
import { EventsService } from 'src/packages/mitsBasics';
import { OfflineDataService } from 'src/packages/mitsBasics';
import { WarehouseOrderModel } from '../models/warehouse-order';
import { StockPositionDisposalModel } from '../models/position';

@Injectable({
  providedIn: 'root',
})
export class WarehouseOrderService extends OfflineDataService<WarehouseOrderModel> {
  constructor(
    public indexedDBService: NgxIndexedDBService,
    public syncProcessor: SyncProcessorService,
    public http: HttpClient,
    public errorService: ErrorService,
    public events: EventsService
  ) {
    super(
      indexedDBService,
      syncProcessor,
      'Warehouse::Order',
      http,
      errorService,
      events,
      'warehouse/orders/',
      'warehouse_order',
      [],
      ['positions', 'bufferstock', 'basket'],
      'bufferstock_id'
    );
  }

  /**
   * Name des Icons für die Klasse
   * @return {string}
   */
  public get iconName(): string {
    return 'document-attach-outline';
  }

  protected cloneObjekt(object: WarehouseOrderModel): WarehouseOrderModel {
    const cloned = { ...object } as Partial<WarehouseOrderModel>;
    delete cloned.bufferstock;
    delete cloned.basket;
    // Entfernt die Verknüpfung zu einem Lagerobjekt um eine circular structure zu verhindern
    if (object.linked_to?.stock_object) {
      delete (object.linked_to.stock_object as any).linked_to;
    }
    if (object.position_disposals)
      cloned.position_disposals = object.position_disposals.map((pos) => {
        const clonedPos = { ...pos } as Partial<StockPositionDisposalModel>;
        delete clonedPos.bufferstock;
        return clonedPos as StockPositionDisposalModel;
      });
    if (object.positions)
      cloned.positions = object.positions.map((pos) => {
        return { ...pos };
      });

    return cloned as WarehouseOrderModel;
  }

  /**
   * Erzeugt/Speichert ein Objekt im Backend (je nachdem ob ID gesetzt)
   * @param object Zu speicherndes/erzeugendes Objekt
   * @param queueId Einbauen
   */
  override saveRemote(
    object: WarehouseOrderModel, queueId: string|null = null
  ): Observable<WarehouseOrderModel> {
    const cloned = this.cloneObjekt(object);
    return this.dataService.save(cloned, queueId);
  }
}
